import { Container, Navbar, Dropdown, Nav, NavDropdown, Col, Modal, Card, Button, Form } from "react-bootstrap"
import Logo from '../../assets/images/app-logo-w.svg'
import { Link, useLocation, useNavigate } from "react-router-dom";
import { HiMenuAlt1 } from "react-icons/hi";
import { Offcanvas } from "react-bootstrap";
import { useEffect, useState } from "react";
import { LuCalendarDays } from "react-icons/lu";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./header.scss";
import WebService from "../../Services/WebService";
import { useDispatch } from "react-redux";
import { resetState } from "../../Redux/action";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { removeToken } from "../../firebase";
import { setTime } from "react-datepicker/dist/date_utils";
import { MdMic, MdMicOff } from "react-icons/md";
import useSpeechToText from "react-hook-speech-to-text";
import { useTranslation } from "react-i18next";

const HeaderNav = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [showDropdown, setShowDropdown] = useState(false);
    const notificationCount = useSelector((state: any) => state.profile.notificationCount) || 0;
    const { t } = useTranslation();
    const handleDropdownItemClick = () => {
        setShowDropdown(false);
    };

    const [startDate, setStartDate] = useState<Date | null>(new Date());
    const [showAddPeople, setShowAddPeople] = useState(false);

    const handleAddPeopleClick = (e: React.MouseEvent) => {
        e.preventDefault(); // Prevent navigation
        setShowDropdown(false); // Close dropdown
        // setShowAddPeople(true); 
        navigate('/add-loved-one');
    };



    const handleClosePeopleModal = () => setShowAddPeople(false);

    return (
        <>
            <Nav className="py-0" >
                <Link to="/home" className={`nav-link ${location.pathname === '/home' ? 'active' : ''}`}>{t("HOME.HOME")}</Link>
                <Link to="/calendar" className={`nav-link ${location.pathname === '/calendar' ? 'active' : ''}`}>{t("CALENDAR.CALENDAR")} </Link>
                <NavDropdown
                    title={t("HOME.ALL_AGENDA")}
                    id="navbarScrollingDropdown"
                    className="mega-menu"
                    autoClose="outside"
                    show={showDropdown}
                    onToggle={(isOpen) => setShowDropdown(isOpen)}
                >
                    <div className="row row-cols-1 row-cols-md-3 gy-3">
                        <Col>
                            <Link
                                to="/agenda/events"
                                className={`dropdown-item ${location.pathname === '/agenda/events' ? 'active' : ''}`}
                                onClick={handleDropdownItemClick}
                            >
                                <span className="title">{t("HOME.EVENTS")}</span>
                                <div className="subtitle">{t("ONBOARDING.EVENTS_DESC")}</div>
                            </Link>
                        </Col>
                        <Col>
                            <Link
                                to="/agenda/reminders"
                                className={`dropdown-item ${location.pathname === '/agenda/reminders' ? 'active' : ''}`}
                                onClick={handleDropdownItemClick}
                            >
                                <span className="title">{t("HOME.REMINDERS")}</span>
                                <div className="subtitle">{t("ONBOARDING.REMINDERS_DESC")}</div>
                            </Link>
                        </Col>
                        <Col>
                            <Link
                                to="#"
                                className="dropdown-item"
                                onClick={handleAddPeopleClick}
                            >
                                <span className="title">{t("ADDLOVEDONE.ADD_CONTACT")}</span>
                                <div className="subtitle">{t("ONBOARDING.ADD_LOVED_ONES_DESC")}</div>
                            </Link>
                        </Col>
                        <Col>
                            <Link
                                to="/agenda/tasks"
                                className={`dropdown-item ${location.pathname === '/agenda/tasks' ? 'active' : ''}`}
                                onClick={handleDropdownItemClick}
                            >
                                <span className="title">{t("HOME.TASKS")}</span>
                                <div className="subtitle">{t("ONBOARDING.TASKS_DESC")}</div>
                            </Link>
                        </Col>
                        <Col>
                            <Link
                                to="/agenda/my-list"
                                className={`dropdown-item ${location.pathname === '/agenda/my-list' ? 'active' : ''}`}
                                onClick={handleDropdownItemClick}
                            >
                                <span className="title">{t("HOME.MY_LISTS")}</span>
                                <div className="subtitle">{t("ONBOARDING.MY_LISTS_DESC")}</div>
                            </Link>
                        </Col>
                    </div>
                </NavDropdown>
                <Link to="/notifications" className={`nav-link ${location.pathname === '/notifications' ? 'active' : ''}`}> {t("NOTIFICATIONS.NOTIFICATIONS")} ({notificationCount})</Link>
                <Link to="/account-settings" className={`nav-link ${location.pathname === '/account-settings' ? 'active' : ''}`}> {t("SETTINGS")}</Link>
            </Nav>

            {/* Add Important People Modal */}
            <Modal show={showAddPeople} onHide={handleClosePeopleModal} centered>
                <Modal.Body className="p-4">
                    <h5 className="text-primary mb-2 font-20 cursor-pointer">
                        Add Important People
                    </h5>
                    <p className="mb-4">Manually enter details for your loved ones</p>

                    <div className="mb-3">
                        <Form.Label className="mb-2">Name <span className="font-12 text-secondary">(Mum, Emily)</span></Form.Label>
                        <Form.Control type="text" placeholder="Name" className="mb-3" />
                    </div>
                    <div className="mb-3">
                        <Form.Label className="mb-2">Relationship <span className="font-12 text-secondary">(Mum, Brother, Partner, Friend, etc.)</span></Form.Label>
                        <Form.Select className="mb-3" style={{ height: '42px' }}>
                            <option value="">Select Relationship</option>
                            <option value="mum">Mum</option>
                            <option value="brother">Brother</option>
                            <option value="partner">Partner</option>
                            <option value="friend">Friend</option>
                        </Form.Select>
                    </div>

                    <div>
                        <Form.Label className="mb-2">Birthday / Anniversary / Special Date <span className="font-12 text-secondary">(Optional: Add multiple!)</span></Form.Label>
                        <div className="mb-3 border rounded px-3 py-2 d-flex">
                            <LuCalendarDays size={22} className="me-2 text-primary-light opacity-50" />
                            <DatePicker
                                selected={startDate}
                                onChange={(date: Date | null) => setStartDate(date)}
                                dateFormat="dd MMM yyyy"
                                className="form-control border-0 p-0 h-auto"
                                placeholderText="Birthday"
                            />
                        </div>
                    </div>


                    <div>
                        <Form.Label className="mb-2">Interests & Hobbies <br /><span className="font-12 text-secondary">Why add interests? If Dad loves football, LOL might suggest match tickets as a birthday gift!</span></Form.Label>
                        <Form.Select className="mb-3" style={{ height: '42px' }}>
                            <option value="">Select Interests & Hobbies</option>
                            <option value="football">Football</option>
                            <option value="music">Music</option>
                            <option value="reading">Reading</option>
                            <option value="travel">Travel</option>
                        </Form.Select>
                    </div>
                    <div className="text-end">
                        <Button variant="link" className="text-decoration-none me-2 text-primary" onClick={handleClosePeopleModal}>Cancel</Button>
                        <Button variant="primary" className=" " onClick={handleClosePeopleModal}>Save</Button>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    )
}

const Header = () => {
    type ResultType = {
        transcript?: string;
        // other properties of ResultType
    };
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [showSearch, setShowSearch] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const fireBaseToken = useSelector((state: any) => state.profile.firebaseToken);
    const userData = useSelector((state: any) => state?.profile?.userInfo) || "";
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [searchResults, setSearchResults] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const micEnabled = useSelector((state: any) => state.profile.microPhoneStatus);
    const handleCloseDeleteModal = () => {
        setShowConfirmationModal(false);
    };

    const handleSearchToggle = () => {
        setShowSearch(!showSearch);
        if (!showSearch) setSearchQuery(""); // reset on close
    };


    const handleConfirmDelete = () => {
        setDeleteLoading(true);
        handleLogout();
        setShowConfirmationModal(false);
    };

    useEffect(() => {
        if (searchQuery.trim() === "") {
            setSearchResults([]);
            return;
        }

        const timer = setTimeout(() => {
            fetchSearchResults(searchQuery);
        }, 300); // debounce 300ms

        return () => clearTimeout(timer);
    }, [searchQuery]);

    const fetchSearchResults = async (keyword: string) => {
        try {
            setLoading(true);
            const res = await WebService.getAPI({
                action: `search?keyword=${encodeURIComponent(keyword)}`,
            }) as any;

            if (res?.success && res?.list) {
                const reminders = res.list.reminders || [];
                const todos = res.list.todos || [];

                const combinedResults = [...reminders, ...todos];
                // setSearchResults(res.lists);
                setSearchResults(combinedResults);
            } else {
                setSearchResults([]);
            }
        } catch (error) {
            setSearchResults([]);
        } finally {
            setLoading(false);
        }
    };


    // const handleSearchToggle = () => {
    //     setShowSearch(!showSearch);
    //     if (showSearch) {
    //         setSearchQuery(''); // Clear search when closing
    //     }
    // };

    const handleLogout = () => {
        if (fireBaseToken !== null) {
            handleUnRegisterDevice();
            setTimeout(() => {
                LogoutAction();
            }, 500);
            setDeleteLoading(false);
        } else {
            LogoutAction();
        }
    }

    const LogoutAction = () => {
        WebService.postAPI({
            action: `logout`,
        })
            .then(async (res: any) => {
                localStorage.clear();
                dispatch(resetState());
                navigate("/login", { replace: true });
                toast.success(res.message);
            })
            .catch((error) => {
                toast.error(error.message);
            }).finally(() => {
                setDeleteLoading(false);
            });
    }

    const handleUnRegisterDevice = () => {
        WebService.postAPI({
            action: `unregister-device`,
            body: {
                token: fireBaseToken,
                push_type: "FCM"
            }
        }).then((res: any) => {

        }).catch((e) => {

        }).finally(async () => {
            await removeToken();
        })
    }

    const handleNavigate = (item: any, path: string) => {
        if (path === "REMINDER") {
            navigate("/agenda/reminders", { state: { searchDataReminder: item?.title } });
        } else if (path === "EVENT") {
            navigate("/agenda/events", { state: { searchDataEvent: item?.title } });
        } else if (path === "TASK") {
            navigate("/agenda/tasks", { state: { searchDataTask: item?.title } });
        } else if (path === "TODO") {
            navigate("/agenda/my-list", { state: { searchDataTodo: item?.title } });
        }
    }
    const [showModal, setShowModal] = useState(false);

    const {
        error,
        isRecording,
        results,
        startSpeechToText,
        stopSpeechToText,
    } = useSpeechToText({
        continuous: true,
        useLegacyResults: false,
    });

    const handleMicClick = () => {
        setShowModal(true);
        // setMicEnabled(true);
        startSpeechToText();
    };

    const handleMicClose = () => {
        setShowModal(false);
        // setMicEnabled(false);
        stopSpeechToText();
    };

    return (
        <>
            <header className="site-header header-nav px-0">
                <Container className=''>
                    <Navbar expand="lg" className="w-100 justify-content-between py-0">
                        <Navbar.Brand className=" ">
                            <a href="javascropt:void(0)" className="me-3 d-inline-block d-md-none" onClick={handleShow}><HiMenuAlt1 color="#fff" size={30} /></a>
                            <img src={Logo} width={90} height={50} alt='' />
                        </Navbar.Brand>
                        <div className="d-none d-md-block">
                            <HeaderNav />
                        </div>
                        <div className="d-flex align-items-center gap-3 justify-content-end">
                            {showSearch ? (
                                <div className="d-flex align-items-center">
                                    <Form.Control
                                        type="text"
                                        placeholder="Search..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        className="me-2 w-100"

                                        autoFocus
                                    />
                                    <button
                                        className="btn btn-link p-0 text-white"
                                        onClick={handleSearchToggle}
                                        style={{ textDecoration: 'none' }}
                                    >
                                        ✕
                                    </button>

                                    {searchResults.length > 0 ? (
                                        <div
                                            className="position-absolute bg-white shadow rounded p-2"
                                            style={{ top: "60px", right: "0", width: "300px", zIndex: 1000 }}
                                        >
                                            {loading ? (
                                                <div className="text-center py-2">Loading...</div>
                                            ) : (
                                                <div style={{ maxHeight: "350px", overflowY: "auto" }}>
                                                    {searchResults.map((item, index) => (
                                                        <div
                                                            key={item.uuid || index}
                                                            className="p-2 border-bottom cursor-pointer"
                                                            onClick={() => {
                                                                handleNavigate(item, item.category || "TODO");
                                                                setSearchResults([]);
                                                                setSearchQuery(item.title || "");
                                                                handleSearchToggle();
                                                            }}
                                                        >
                                                            <strong>{item.title}</strong>
                                                            <div className="text-muted font-small">
                                                                {item.category || "TODO"}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        searchQuery && !loading && (<div
                                            className="position-absolute bg-white shadow rounded p-2"
                                            style={{ top: "60px", right: "0", width: "300px", zIndex: 1000 }}
                                        > No results found. </div>
                                        )
                                    )}
                                </div>
                            ) : (
                                <button
                                    className="btn btn-link p-0"
                                    onClick={handleSearchToggle}
                                    aria-label="search"
                                    style={{ textDecoration: 'none' }}
                                >
                                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8 0C12.4183 0 16 3.58172 16 8C16 9.8486 15.3703 11.5487 14.3174 12.9033L18.707 17.293C19.0976 17.6835 19.0976 18.3165 18.707 18.707C18.3165 19.0976 17.6835 19.0976 17.293 18.707L12.9033 14.3174C11.5487 15.3703 9.8486 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2Z" fill="white" />
                                    </svg>
                                </button>
                            )}
                            {/* <div className="d-flex align-items-center">
                                {micEnabled && (
                                    <MdMic className="text-white" size={25} title="Microphone enabled" />
                                )}
                            </div> */}
                            {/* <div className="d-flex align-items-center">
                                {micEnabled && (
                                    <MdMic
                                        className="text-white"
                                        size={25}
                                        title="Microphone enabled"
                                        onClick={handleMicClick}
                                        style={{ cursor: "pointer" }}
                                    />
                                )}
                            </div> */}
                            <Link to="/profile">
                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.66663 17.9999C1.66663 16.7622 2.15829 15.5753 3.03346 14.7001C3.90863 13.8249 5.09562 13.3333 6.33329 13.3333H15.6666C16.9043 13.3333 18.0913 13.8249 18.9665 14.7001C19.8416 15.5753 20.3333 16.7622 20.3333 17.9999C20.3333 18.6188 20.0875 19.2122 19.6499 19.6498C19.2123 20.0874 18.6188 20.3333 18 20.3333H3.99996C3.38112 20.3333 2.78763 20.0874 2.35004 19.6498C1.91246 19.2122 1.66663 18.6188 1.66663 17.9999Z" stroke="white" stroke-width="2.33333" stroke-linejoin="round" />
                                    <path d="M11 8.66663C12.933 8.66663 14.5 7.09962 14.5 5.16663C14.5 3.23363 12.933 1.66663 11 1.66663C9.067 1.66663 7.5 3.23363 7.5 5.16663C7.5 7.09962 9.067 8.66663 11 8.66663Z" stroke="white" stroke-width="2.33333" />
                                </svg>
                            </Link>
                            {/* <Link to="/profile"> */}
                            <button onClick={() => setShowConfirmationModal(true)} className="logout-btn" aria-label="logout">
                                <svg
                                    width="22"
                                    height="22"
                                    viewBox="0 0 22 22"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M8.66663 11H20.3333M20.3333 11L16.8333 7.5M20.3333 11L16.8333 14.5"
                                        stroke="white"
                                        stroke-width="1.75"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M1.66663 11C1.66663 8.52461 2.64996 6.15064 4.4003 4.4003C6.15064 2.64996 8.52461 1.66663 11 1.66663M11 20.3333C9.60071 20.3341 8.21922 20.02 6.95795 19.4141C5.69669 18.8082 4.588 17.9261 3.71413 16.8333"
                                        stroke="white"
                                        stroke-width="1.75"
                                        stroke-linecap="round"
                                    />
                                </svg>
                            </button>
                            {/* </Link> */}
                        </div>
                    </Navbar>
                </Container>
            </header>
            {/* Offcanvas for mobile menu */}
            <Offcanvas show={show} onHide={handleClose} placement="start" className="mobile-modal">
                <Offcanvas.Header closeButton className="border-bottom bg-primary">
                    <Offcanvas.Title>
                        <img src={Logo} width={67} height={37} alt="Logo" />
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="mobile-nav">
                    <div className="nav-links">
                        <HeaderNav />
                    </div>
                </Offcanvas.Body>
            </Offcanvas>


            <Modal
                show={showConfirmationModal}
                onHide={handleCloseDeleteModal}
                centered
            >
                <Modal.Body className="p-4">
                    <h5 className="mb-3">{t("LOGOUT.TITLE")}</h5>

                    <p>{t("LOGOUT.MESSAGE")}</p>

                    <div className="text-end">
                        <Button
                            variant="secondary"
                            className="me-2"
                            onClick={handleCloseDeleteModal}
                        >
                            {t("LOGOUT.CANCEL")}
                        </Button>
                        <Button variant="primary" onClick={handleConfirmDelete}>
                            {deleteLoading ? "loading..." : t("LOGOUT.CONFIRM")}
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={showModal} onHide={handleMicClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Speak something...</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && <p className="text-danger">Error: {error}</p>}
                    <div
                        style={{
                            background: "#f8f9fa",
                            padding: "10px",
                            minHeight: "100px",
                            borderRadius: "8px",
                            border: "1px solid #dee2e6",
                        }}
                    >
                        {results.length > 0 ? (
                            results.map((result, i) => (
                                <p key={i} className="mb-1">
                                    {(result as ResultType)?.transcript?.toString()}
                                </p>
                            ))
                        ) : (
                            <p className="text-muted">Listening...</p>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isRecording ? (
                        <Button variant="danger" onClick={handleMicClose}>
                            Stop & Close
                        </Button>
                    ) : (
                        <Button variant="primary" onClick={startSpeechToText}>
                            Start Again
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default Header;